export const BUSINESS_CARDS_INCREMENT_EXPERIMENT_NAME = 'business_cards_popular_templates_and_stock_options_test'

export const BUSINESS_CARDS_INCREMENT_TREATMENT_NAME = 'businesscard_popular_template_signed_in_test'

export const BUSINESS_CARDS_INCREMENT_EXPERIMENT_VARIATION_1 = 'test'

export const BUSINESS_CARDS_INCREMENT_EXPERIMENT_VARIATION_2 = 'test_2'

export const BUSINESS_CARDS_INCREMENT_EXPERIMENT_CONTROL = 'control'

export const BUSINESS_CARDS_INCREMENT_EXPERIMENT_SUPPORTED_MC_IDS = ['businessCards']

export const BUSINESS_CARDS_INCREMENT_EXPERIMENT_SUPPORTED_LOCALES = ['en-US', 'es-US', 'en-GB']
